/**
 * Rótulos e cores compartilhados pelas telas de campanha.
 *
 * A situação da campanha aparece em três lugares (lista, editor, relatório) e
 * precisa dizer a mesma coisa nos três — por isso mora aqui, e não espalhada.
 */

export const STATUS = {
  draft: { label: 'Rascunho', color: '' },
  scheduled: { label: 'Agendada', color: 'blue' },
  sending: { label: 'Enviando', color: 'orange' },
  sent: { label: 'Enviada', color: 'green' },
  canceled: { label: 'Cancelada', color: 'red' },
};

export const statusLabel = (status) =>
  (STATUS[status] && STATUS[status].label) || status;

export const statusColor = (status) =>
  (STATUS[status] && STATUS[status].color) || '';

export const SOURCE_LABEL = {
  empresa: 'E-mail da empresa',
  painel: 'Usuários do painel',
  ambos: 'Empresa + painel',
};

/**
 * O funil em linguagem de gente. Cada linha só aparece quando tem valor — uma
 * lista com "0 duplicados" e "0 na blacklist" esconde o que importa.
 */
export const explicaFunil = (funil) => {
  if (!funil) return [];

  const linhas = [];
  if (funil.sem_email) linhas.push(funil.sem_email + ' sem e-mail cadastrado');
  if (funil.duplicados) linhas.push(funil.duplicados + ' endereço(s) repetido(s)');
  if (funil.blacklist) linhas.push(funil.blacklist + ' na blacklist');
  if (funil.descadastrados) linhas.push(funil.descadastrados + ' pediram descadastro');
  return linhas;
};

/**
 * O funil como subtração, linha a linha — o formato em que a conta fecha na
 * cabeça de quem lê: parte-se dos clientes do filtro e tira-se cada grupo até
 * sobrar quem recebe.
 *
 * Grupos com zero saem da lista: "0 na blacklist" ocupa espaço e não informa.
 */
export const linhasDoFunil = (funil) => {
  if (!funil) return [];

  const perdas = [
    { chave: 'sem_email', valor: funil.sem_email, rotulo: 'sem e-mail cadastrado', cor: '#fa8c16',
      ajuda: 'Cliente no filtro que não tem endereço na ficha. É tarefa para o time, não erro do envio.' },
    { chave: 'duplicados', valor: funil.duplicados, rotulo: 'endereços repetidos', cor: '#8c8c8c',
      ajuda: 'O mesmo e-mail servindo várias empresas. Recebe uma vez só.' },
    { chave: 'blacklist', valor: funil.blacklist, rotulo: 'na blacklist', cor: '#cf1322',
      ajuda: 'Endereço que já deu erro permanente ou recusou. Não recebe de ninguém.' },
    { chave: 'descadastrados', valor: funil.descadastrados, rotulo: 'pediram descadastro', cor: '#722ed1',
      ajuda: 'Saiu das campanhas por vontade própria. Continua recebendo guias e documentos.' },
  ];

  return perdas.filter((p) => p.valor > 0);
};

/** "5 min" / "1 h 20 min" — a previsão de quanto o disparo leva. */
export const formataDuracao = (minutos) => {
  if (!minutos || minutos < 1) return 'menos de 1 min';
  if (minutos < 60) return minutos + ' min';

  const horas = Math.floor(minutos / 60);
  const resto = minutos % 60;
  return horas + ' h' + (resto ? ' ' + resto + ' min' : '');
};

export const taxa = (parte, total) => {
  if (!total) return '—';
  return Math.round((parte / total) * 100) + '%';
};
